/* ============================================================
   LOCK-IN — MASCOTTE : contrôleur d'états
   API globale :
     LockinMascot.set(el, 'happy')            — change l'état
     LockinMascot.pulse(el, 'happy', 2200)    — état temporaire, puis retour à l'état d'origine
     LockinMascot.all('happy')                — change toutes les mascottes de la page
   el = élément .lkm (ou sélecteur CSS).
   Le snippet peut être rendu plusieurs fois par page : ce fichier
   est donc chargé plusieurs fois — le garde-fou ci-dessous ne le
   laisse s'exécuter qu'une seule fois.
   ============================================================ */
(function () {
  if (window.LockinMascot) return;

  var STATES = ['idle', 'focus', 'sleep', 'happy'];

  function resolve(el) {
    if (typeof el === 'string') el = document.querySelector(el);
    return el && el.hasAttribute && el.hasAttribute('data-lkm') ? el : null;
  }

  function current(el) {
    for (var i = 0; i < STATES.length; i++) {
      if (el.classList.contains('lkm--' + STATES[i])) return STATES[i];
    }
    return 'idle';
  }

  window.LockinMascot = {
    set: function (el, state) {
      el = resolve(el);
      if (!el || STATES.indexOf(state) === -1) return;
      STATES.forEach(function (s) {
        el.classList.toggle('lkm--' + s, s === state);
      });
    },

    pulse: function (el, state, duration) {
      el = resolve(el);
      if (!el || STATES.indexOf(state) === -1) return;
      // L'état de retour est celui d'origine (posé par le snippet), pas
      // l'état courant — deux pulses rapprochés ne se polluent pas.
      var back = el.getAttribute('data-lkm-state') || 'idle';
      this.set(el, state);
      clearTimeout(el._lkmTimer);
      el._lkmTimer = setTimeout(function () {
        window.LockinMascot.set(el, back);
      }, duration || 2200);
    },

    all: function (state) {
      var self = this;
      document.querySelectorAll('[data-lkm]').forEach(function (el) {
        self.set(el, state);
      });
    }
  };
})();
